import { useState, useEffect } from 'react'

interface TerminalCardProps {
  command: string
  output: string | null // null = not run yet, string = results
  onRun: () => void
}

export function TerminalCard({ command, output, onRun }: TerminalCardProps) {
  const [ran, setRan] = useState(!!output)

  // Auto-mark as ran when output arrives
  useEffect(() => { if (output !== null) setRan(true) }, [output])

  const handleRun = () => {
    setRan(true)
    onRun()
  }

  return (
    <div style={{
      borderRadius: 7, overflow: 'hidden', margin: '6px 0',
      border: '1px solid var(--border)', background: 'var(--bg-0)',
    }}>
      {/* Header */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '5px 10px', background: 'var(--bg-3)',
        borderBottom: '1px solid var(--border)',
        fontSize: '9.5px', fontFamily: 'var(--font-mono)', color: 'var(--text-2)',
      }}>
        <span>shell</span>
        <div style={{ display: 'flex', gap: 6 }}>
          <button
            onClick={() => navigator.clipboard.writeText(command + (output ? '\n' + output : ''))}
            style={{
              background: 'none', border: '1px solid var(--border-2)', borderRadius: 4,
              color: 'var(--text-2)', cursor: 'pointer', fontSize: 9,
              fontFamily: 'var(--font-mono)', padding: '2px 7px',
            }}
          >copy</button>
          <button
            onClick={handleRun}
            disabled={ran}
            style={{
              background: 'none', borderRadius: 4, fontSize: 9,
              fontFamily: 'var(--font-mono)', padding: '2px 7px',
              border: ran ? '1px solid var(--border-2)' : '1px solid rgba(95,212,164,0.3)',
              color: ran ? 'var(--text-2)' : 'var(--accent-2)',
              cursor: ran ? 'default' : 'pointer',
              opacity: ran ? 0.6 : 1,
            }}
          >{output !== null ? '✓ done' : ran ? '⏳ running' : '▶ run'}</button>
        </div>
      </div>
      {/* Body */}
      <pre style={{
        padding: '10px 12px', fontFamily: 'var(--font-mono)', fontSize: 11,
        color: 'var(--accent-2)', lineHeight: 1.6, overflowX: 'auto', margin: 0,
        whiteSpace: 'pre-wrap', wordBreak: 'break-all',
      }}>
        <span style={{ color: 'var(--text-1)' }}>$ </span>{command}
        {output && (
          <span style={{ display: 'block', marginTop: 8, color: 'var(--text-0)', borderTop: '1px solid var(--border)', paddingTop: 8 }}>
            {output}
          </span>
        )}
      </pre>
    </div>
  )
}
